<!-- <div class="row search-input">
  <div class="col-12"><img src="../../../../assets/images/search.png"><input type="text"
      placeholder="Type here to search…"></div>
</div>

<div class="admin-coadmin-layout mt-2">
  <div class="row pr-4">
    <div class="col-9 text pt-3">{{list?.length}} admin</div>


    <div class="col-3 d-flex justify-content-end ">
      <label class="check-container">
        <input type="checkbox">
        <span class="checkmark" style="margin-top: 13px;"></span>
      </label>
      <p class="pl-3 pt-3 text-select">select all</p>
      <div class="list-option pl-4" (click)="$event.stopPropagation();openOptionDrawer = !openOptionDrawer">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div *ngIf="openOptionDrawer" class="drawer-container">
          <div>
            <p (click)="$event.stopPropagation()">Revoke co-admin access</p>
          </div>
        </div>
      </div>
    </div>



  </div>


  <ng-container *ngIf="list">
    <div class="mt-3" *ngFor='let item of list'>
      <list [list]='item'></list>
    </div>
  </ng-container>

  <div class="coadmin-box mt-3" *ngFor='let item of coadmins'>
    <div class="row ">
      <div class="col-11">
        <h1>Co-admin {{item.coadminNo}}</h1>
      </div>
      <div class="col-1"><button *ngIf="coadmins.length>1" type="submit"
          (click)="removeCoadmin(item.coadminNo)">Clear</button></div>
    </div>

    <div class="mt-3 row" id="employeeType">
      <div class="col-5 d-flex">
        <input type="radio" class=" mr-2 mt-1" value="a" name="type" (change)="onItemChange($event.target.value)">
        <label for="Internal employee" class="radio-label ">Internal employee</label>
        <input type="radio" class=" mr-2 ml-5 mt-1" value="b" name="type" (change)="onItemChange($event.target.value)">
        <label for="External employee" class="radio-label">External employee</label>
      </div>
      <div class="col-7"></div>
    </div>

    <div class="row mt-3">
      <div class="col-4">
        <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
          class="search-line  pl-4 placeholder-text " [placeholder]="!name ? 'Full Name' : ''"
          (click)="enterName('name')" (blur)="enterName('name')" (ngModelChange)="inputModelChange(1,'name')">
        <label *ngIf="name" class="form-lable">Full Name</label>
      </div>
      <div class="col-4">
        <input type="text" [ngClass]="mobile?'textbox-onselect':'textbox-style'"
          class="search-line  pl-4 placeholder-text " [placeholder]="!mobile ? 'Mobile Number' : ''"
          (click)="enterName('mobile')" (blur)="enterName('mobile')" (ngModelChange)="inputModelChange(1,'mobile')">
        <label *ngIf="mobile" class="form-lable">Mobile Number</label>
      </div>
      <div class="col-4">
        <input type="text" [ngClass]="email?'textbox-onselect':'textbox-style'"
          class="search-line  pl-4 placeholder-text " [placeholder]="!email ? 'Email-ID' : ''"
          (click)="enterName('email')" (blur)="enterName('email')" (ngModelChange)="inputModelChange(1,'email')">
        <label *ngIf="email" class="form-lable">Email-ID</label>
      </div>
    </div>
  </div>


  <div class="row mt-3">
    <div class="col-4">
      <button type="submit" (click)="addCoadmin()">+ Add another admin</button>
    </div>
    <div class="col-8"></div>
  </div>


  <hr>

  <div class="row">
    <div class="col-8"></div>
    <div class="col-2"><button class="cancel-button">Cancel</button></div>
    <div class="col-2"><button class="save-button">Save</button></div>

  </div>


</div> -->


<div class="row search-input">
  <div class="col-12"><img src="../../../../assets/images/search.png">
    <!-- <input type="text" name="searchText"
      id="searchText" placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="searchByText(searchText)"
      (search)="searchByText(searchText)"> -->
    <input type="text" placeholder="Type here to search…" [(ngModel)]="searchText" (keyup)="getEmployeeByFilter()">
  </div>
</div>

<form [formGroup]="Form" (submit)="SaveData()" *ngIf="isLoaded">
  <div class="admin-coadmin-layout mt-2" *ngIf="isTenantExpired=='false'">
    <div class="row pr-4">
      <div class="col-9 text pt-3">{{adminCount}} Admin &nbsp;&nbsp;|&nbsp;&nbsp; {{coAdminCount}} Co-Admin</div>
      <div class="col-3 d-flex justify-content-end" *ngIf="companyAdd">
        <!-- <input class="mt-3" type="checkbox"> -->
        <label class="check-container">
          <input type="checkbox" (click)="selectDeselectUsers()" [checked]="isChecked">
          <span class="checkmark mt-3"></span>
        </label>
        <p class="pl-3 pt-3 text-select">select all</p>
        <div class="list-option pl-4"
          (click)="$event.stopPropagation();captureClick($event);openOptionDrawer = !openOptionDrawer"
          *ngIf="selectedUsers.length > 0 && (dropdownFlag || dropdownFlag2)">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div *ngIf="openOptionDrawer" class="drawer-container">
            <div>
              <p (click)="markAsAdmin()" *ngIf="dropdownFlag" [clickable]="this.selectedUsers.length > 0">Mark as admin
              </p>
              <p (click)="removeAsAdmin()" *ngIf="dropdownFlag2" [clickable]="this.selectedUsers.length > 0">Remove as
                admin</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="newList != null && newList.length > 0">
      <div class="mt-3" *ngFor='let item of newList'>
        <list [list]='item' [displayType]="displayType.AdminCoadmin" (markUser)="markAsAdmin($event)"
          (removeUser)="removeAsAdmin($event)" (selectedCheckBox)="getSelectedUser($event)" [count]="adminCount"
          [checked]="checkboxValue" (dotClicked)="dotDropDownDetail=$event;openOptionDrawer=false"
          [checkPopupFlag]="dotDropDownDetail"></list>
      </div>
    </ng-container>

    <div>
      <div class="coadmin-box mt-3" formArrayName="users" *ngFor="let item of users.controls; let i=index">
        <div [formGroupName]="i">
          <div class="row ">
            <div class="col-11">
              <h1>Admin {{i+1}}</h1>
            </div>
            <div class="col-1"><button *ngIf="coadmins.length>1" type="button" (click)="removeCoadmin(i)">Clear</button>
            </div>
          </div>

          <div class="mt-3 row" id="employeeType">
            <div class="col-5 d-flex">
              <input type="radio" class=" mr-2 mt-1" value="a" name="type{{i}}"
                (change)="onItemChange($event.target.value, i)" [checked]="emailCheck[i]=='a'">
              <label for="Internal employee" class="radio-label ">Internal employee</label>
              <input type="radio" class=" mr-2 ml-5 mt-1" value="b" name="type{{i}}"
                (change)="onItemChange($event.target.value, i)" [checked]="emailCheck[i]=='b'">
              <label for="External employee" class="radio-label">External employee</label>
            </div>
            <div class="col-7"></div>
          </div>

          <div class="row mt-3">
            <div class="col-4">
              <div class="col-12" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                [ngbPopover]="popContentBuildingName" triggers="manual" #p="ngbPopover"
                (blur)="enterName('buildingName')" placement="bottom" popoverClass='dash-popover dashboard-popover'>
                <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                  class="search-line  pl-4 placeholder-text " [placeholder]="!name ? 'Full Name' : ''"
                  (click)="enterName('name')" (keyup)="getEmployeeListOnKeyDown($event.target.value, p)"
                  (blur)="enterName('name')" formControlName="name" (ngModelChange)="inputModelChange(1,'name')">
                <label *ngIf="name" class="form-lable">Full Name</label>
                <div *ngIf="submitted && item.controls.name.errors" class="error-fields">
                  <div *ngIf="item.controls.name.errors.required">*Name is required</div>
                </div>
                <ng-template #popContentBuildingName>
                  <div class="dashboard-popover">
                    <div class="d-flex justify-content-between">
                      <div class="pl-3 pt-3 pr-3 pb-3 " style="width: 100%;">
                        <div class="row pb-2 flexWrapunset" *ngFor="let item of employeeDropdownList"
                          (click)="openPopover(p);selectEmp(item, i)"
                          style="justify-content: space-between;cursor: pointer;">
                          <div class="popover-content normal-font pl-3 email-width word-wrap"
                            style="font-size: 16px;color: #707070;font-family: 'Montserrat-medium';">
                            {{item.empName}} <span *ngIf="item.employeeRole !== 'User'">| {{item.employeeRole}}</span>
                          </div>
                          <!-- <div style="margin-right: 10px;">
                        <img src="assets/images/company/tick.png" *ngIf="item.checked">
                      </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>

            <div class="col-4">
              <input type="text" style="padding-left: 30px !important;"
                [ngClass]="mobile?'textbox-onselect':'textbox-style'" class="search-line  pl-4 placeholder-text "
                [placeholder]="!mobile ? 'Mobile Number' : ''" (click)="enterName('mobile')"
                (blur)="enterName('mobile')" formControlName="phoneNumber"
                (ngModelChange)="inputModelChange(1,'mobile')">
              <div class="unit" style="position: absolute;top: 0;margin-top: 17px;">+91</div>
              <label *ngIf="mobile" class="form-lable">Mobile Number</label>
              <div *ngIf="submitted && item.controls.phoneNumber.errors" class="error-fields">
                <div *ngIf="item.controls.phoneNumber.errors.required">*Mobile number is required</div>
                <div *ngIf="item.controls.phoneNumber.errors.pattern">*Mobile number is invalid</div>
              </div>
            </div>

            <div class="col-4">
              <!-- <input type="text" [ngClass]="email?'textbox-onselect':'textbox-style'"
              class="search-line  pl-4 placeholder-text " [placeholder]="!email ? 'Email-ID' : ''"
              (click)="enterName('email')" (blur)="enterName('email')" (ngModelChange)="inputModelChange(1,'email')" formControlName="email"> -->
              <input type="text" [ngClass]="email?'textbox-onselect':'textbox-style'"
                class="search-line  pl-4 placeholder-text " [placeholder]="!email ? 'Email-ID' : ''"
                (click)="enterName('email')" (blur)="enterName('email')" formControlName="email"
                (ngModelChange)="inputModelChange(1,'email')" #input [appEmailRestricter]="emailCheck[i]"
                [changedVal]="item.controls.email.value">
              <!-- <span id="clearBtn1" class="clearBtn show" *ngIf="emailCheck[i]=='a'">{{emailDisplay}}</span> -->
              <span id="clearBtn1" class="clearBtn show" *ngIf="emailCheck[i]=='a'">
                <select class="selectDropdown" (change)="selectedEmailDomain(i,$event.target.value)">
                  <option *ngFor="let eDomain of emailDomains">{{eDomain}}</option>
                </select>
              </span>
              <label *ngIf="email" class="form-lable">Email-ID</label>
              <div *ngIf="submitted && item.controls.email.errors" class="error-fields">
                <div *ngIf="item.controls.email.errors.required">*Email is required</div>
                <div *ngIf="item.controls.email.errors.email">*Email is invalid</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row mt-3" *ngIf="isRoleAdmin">
      <div class="col-4" *ngIf="companyAdd">
        <button type="button" (click)="addCoadmin()">+ Add another Admin</button>
      </div>
      <div class="col-8"></div>
    </div>
  </div>
  <div class="row actionButtonDiv" *ngIf="users.length > 0 && isTenantExpired=='false'">
    <div class="col-8"></div>
    <div class="col-2"><button type="button" class="cancel-button" (click)="clearBoxes()">Cancel</button></div>
    <div class="col-2"><button class="save-button" type="submit">Save</button>
    </div>
  </div>
</form>

<!-- <ng-container *ngIf="isLoadData">
    <div class="mt-3" *ngFor='let item of list  | paginate: { itemsPerPage: pageSize,
      currentPage: page,
      totalItems:totalCount }'>
      <list [list]='item' [displayType]="displayType.Active" (markUser)="markAsAdmin($event)" (removeUser)="removeAsAdmin($event)" (selectedStatus)="changeEmpStatus($event)"  (selectedCheckBox)="getSelectedUser($event)" [checked]="checkboxValue" (dotClicked)="dotDropDownDetail=$event;openOptionDrawer=false" [checkPopupFlag]="dotDropDownDetail"></list>
    </div>
    <empty-state *ngIf="((list !== null && list?.length <= 0) || list === null)"></empty-state>
  </ng-container> -->
<div class="pagination justify-content-center" style="margin-top: 20px;">
  <div class="d-flex  pagination-section" *ngIf="totalCount>=10">
    <div class="row d-flex pagination-border">
      <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
        class="d-flex justify-content-center">
      </pagination-controls>
      <!-- <div class="pr-3 ratio-class pt-1" *ngIf="member?.length>=10">10/{{members?.list?.length}}</div> -->
      <div class="pr-3 ratio-class pt-1">
        {{page}}/{{(noPages)}}</div>
      <!-- <div class="pr-3 ratio-class pt-1">10/{{members?.list?.length}}</div> -->
    </div>
  </div>
</div>